import { lazy, Suspense } from 'react'

import { createBrowserRouter } from 'react-router-dom'
import { authRoutes } from './router/auth.routes'
import { protectedLoader } from './router/protectedLoader'
import { PATHROUTES } from './constants/path'
import * as Sentry from '@sentry/react'

import DashboardLayout from './components/Layout/dashboard-layout'
import CustomLoader from './components/CustomLoader'
import ProtectedRoute from './components/ProtectedRoute'
import DefaultRedirect from './components/DefaultRedirect'
import { PROTECTED_ROUTES } from './config/routes.config'

const Styleguide = lazy(() => import('./components/Styleguide'))
const RoleSelection = lazy(() => import('./pages/Auth/RoleSelection'))

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter)

function generateProtectedRoutes() {
  return PROTECTED_ROUTES?.map(route => {
    const RouteComponent = route.component

    return {
      path: route.path,
      element: (
        <ProtectedRoute>
          <Suspense fallback={<CustomLoader />}>
            <RouteComponent />
          </Suspense>
        </ProtectedRoute>
      ),
    }
  })
}

export const router = sentryCreateBrowserRouter([
  ...authRoutes,

  // Protected routes
  {
    path: PATHROUTES.STYLE_GUIDE,
    element: <Styleguide />,
  },

  {
    path: PATHROUTES.ROOT,
    loader: protectedLoader,
    children: [
      {
        path: '',
        element: <DefaultRedirect />,
      },
      {
        path: PATHROUTES.DASHBOARD.ROOT,
        element: (
          <Suspense fallback={<CustomLoader />}>
            <DashboardLayout />
          </Suspense>
        ),
        children: generateProtectedRoutes(),
      },
      {
        path: PATHROUTES.AUTH.ROLE_SELECTION,
        element: <RoleSelection />,
      },
    ],
  },
  {
    path: '*',
    element: <DefaultRedirect />,
  },
])
